import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ServiceSeoLanding } from '../components/ServiceSeoLanding';
import { PortfolioSeoSection } from '../components/portfolio/PortfolioSeoSection';
import { getServicePageContent } from '../seo/service-pages';
import { isPortfolioSeoPath } from '../seo/portfolio-category-map';
import { SERVICE_SLUG_BY_PATH } from '../seo/static-routes';

const GALLERY_TITLE_BY_PATH: Record<string, string> = {
  '/portfolio/mariage': 'Reportages mariage — Tunis & Djerba',
  '/portfolio/photobooth': 'Animations photobooth — mariages & événements',
  '/portfolio/corporate': 'Films corporate & événements professionnels',
  '/portfolio/shooting': 'Shootings studio, clips & packshot',
};

export function PortfolioSeoPage() {
  const { pathname } = useLocation();
  const slug = SERVICE_SLUG_BY_PATH[pathname];
  const [portfolioCtaHref, setPortfolioCtaHref] = useState('/portfolio');

  if (!slug || !isPortfolioSeoPath(pathname)) {
    return <Navigate to="/portfolio" replace />;
  }

  const content = getServicePageContent(slug);
  if (!content) return <Navigate to="/portfolio" replace />;

  return (
    <>
      <ServiceSeoLanding content={content} portfolioCtaHref={portfolioCtaHref} />
      <PortfolioSeoSection
        seoPath={pathname}
        galleryTitle={GALLERY_TITLE_BY_PATH[pathname]}
        onCtaResolved={setPortfolioCtaHref}
      />
    </>
  );
}
